<template>
  <v-card>
    <v-card-title>Image Use Agreement</v-card-title>
    <v-card-text>
      <p>
        By checking the box and signing below, you confirm that you have read, understood,
        and agreed to the following terms:
      </p>
      <p>
        All images made available for download on this website are the intellectual
        property of Doricmor Ltd (or its licensors) and are provided solely for the
        purpose of promoting and selling Doricmor products.
      </p>
      <p>
        You are granted a non-exclusive, non-transferable licence to use these images
        strictly for use on your own website, social media platforms, and other direct
        marketing channels, solely in connection with the promotion and resale of Doricmor
        products. Images must not be altered, reproduced, distributed, or used for any
        other purpose, including but not limited to inclusion in product catalogues for
        non-Doricmor products, incorporation into new artwork, or resale in any form.
      </p>
      <p>
        Any unauthorised use will result in immediate revocation of access, termination of
        your trade account, and legal action.
      </p>
      <v-checkbox
        small
        label="I agree to these terms and conditions"
        v-model="check"
      ></v-checkbox>
      <v-text-field
        label="Name"
        dense
        outlined
        placeholder="Type your full name"
        v-model="name"
        :rules="[rules.required]"
      ></v-text-field>
      <label>Signature</label>
      <vueSignature
        id="signature"
        ref="signature"
        :sigOption="option"
        :disabled="disabled"
        @endStroke="updateStroke"
      ></vueSignature>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" :disabled="!confirmed" @click="save">Agree</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="clear">Clear</v-btn>
      <v-btn color="primary" @click="cancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import vueSignature from "vue-signature";
import MarketingApi from "@/api/customer/marketing";
export default {
  components: {
    vueSignature,
  },
  data: () => ({
    dialog: false,
    resolve: null,
    isEmpty: true,
    check: false,
    name: null,
    signature: null,
    reject: null,
    message: null,
    title: null,
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(255,255,255)",
    },
    disabled: false,
    dataUrl: "https://avatars2.githubusercontent.com/u/17644818?s=460&v=4",
    options: {
      color: "primary",
      width: 500,
      zIndex: 200,
    },
    rules: {
      required: (value) => (!!value && value.length > 8) || "Too few characters.",
    },
  }),
  computed: {
    confirmed() {
      return !this.isEmpty && this.check && this.name;
    },
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      var _this = this;
      var png = _this.$refs.signature.save();
      var jpeg = _this.$refs.signature.save("image/jpeg");
      var svg = _this.$refs.signature.save("image/svg+xml");
      const agreement = {
        check: _this.check,
        name: _this.name,
        signature: png,
      };
      MarketingApi.saveImageUseAgreement(agreement).then((res) => {
        this.imageUseAgreement = res.data.check;
        this.$emit("onChange", res.data.imageUseAgreement.check);
      });

      _this.isEmpty = true;
      _this.check = false;
      _this.$refs.signature.clear();
    },
    clear() {
      var _this = this;
      _this.isEmpty = true;
      _this.$refs.signature.clear();
    },
    undo() {
      var _this = this;
      _this.$refs.signature.undo();
    },
    updateStroke(x) {
      var _this = this;
      var png = _this.$refs.signature.save();
      var base64str = png.substr(22);
      var decoded = atob(base64str);
      _this.isEmpty = decoded.length < 8000;
    },
    addWaterMark() {
      var _this = this;
      _this.$refs.signature.addWaterMark({
        text: "mark text", // watermark text, > default ''
        font: "20px Arial", // mark font, > default '20px sans-serif'
        style: "all", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
        fillStyle: "red", // fillcolor, > default '#333'
        strokeStyle: "blue", // strokecolor, > default '#333'
        x: 100, // fill positionX, > default 20
        y: 200, // fill positionY, > default 20
        sx: 100, // stroke positionX, > default 40
        sy: 200, // stroke positionY, > default 40
      });
    },
    fromDataURL(url) {
      var _this = this;
      _this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
    },
    handleDisabled() {
      var _this = this;
      _this.disabled = !_this.disabled;
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      var _this = this;
      _this.isEmpty = true;
      _this.check = false;
      _this.name = null;
      _this.$refs.signature.clear();
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
#signature {
  border: 1px solid silver !important;
}
</style>
